var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSib(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32842)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#057BC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 2.25C5.27231 2.25 2.25 5.27231 2.25 9C2.25 12.7277 5.27231 15.75 9 15.75C12.7277 15.75 15.75 12.7277 15.75 9C15.75 7.20979 15.0388 5.4929 13.773 4.22703C12.5071 2.96116 10.7902 2.25 9 2.25ZM11.349 11.5464H11.0745V13.0832H10.152V11.5464H8.74744V10.9755H10.1745V9.94387C9.43355 10.3568 8.57118 10.4965 7.73775 10.3387C7.2765 10.2291 6.81581 9.97706 6.5745 9.55969C6.34522 9.1516 6.23128 8.68883 6.24488 8.22094V5.78419H7.17806V8.30869C7.2 8.85712 7.551 9.40612 8.08931 9.57094C8.79724 9.73349 9.54061 9.61534 10.1633 9.24131C10.1633 8.47294 10.152 7.32094 10.1633 5.78419H11.1071V10.9761H11.349V11.5464Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32842"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSib);
export default __webpack_public_path__ + "static/media/sib.4d08fc1dfd80f9754399dc2224d576e2.svg";
export { ForwardRef as ReactComponent };